export default {
  getQuestion: (state) => state.question,
};
